export default function (state = [], action) {
    switch (action.type) {
        case "CURRENT_QUERY":
            return action.payload;
            break;
        default:
            return state;
    }
}
